<template>
  <PageHeader
    title="Felvételek"
    hero-class="bg-media hidden lg:flex"
    :breadcrumb="[ 'Médiatár','Felvételek' ]"
  >
    <section
      @keyup.enter="$refs.search.submit()"
    >
      <div class="bg-white w-full p-6">
        <client-only>
          <MediaSearch
            ref="search"
            through="recordings"
            :query-object="queryObject"
            @searchChanged="searchChanged($event)"
          />
        </client-only>
      </div>
      <div 
        ref="entitiesList"
        class="bg-white w-full mt-7"
      >
        <!-- $fetchState.pending || isLoading -->
        <ReOverlayLoader
          :loading="$fetchState.pending || isLoading"
          class="pb-8"
        >
          <RePagination
            :items="entities"
            :hide-page-selector="true"
            result-title="Felvételek száma"
          />
          <div
            v-if="$fetchState.pending"
            class="d-flex justify-content-center"
          >
            <div
              class="spinner-border"
              role="status"
            >
              <span class="sr-only">Töltés...</span>
            </div>
          </div>
          <div class="bg-gray-lightest lg:bg-white p-[30px]">
            <div
              v-if="!$fetchState.pending"
              class="hidden lg:flex py-[10px]  font-semibold bg-gray-lightest mb-3"
            >
              <div class="w-5/12 px-[15px]">
                <p class=" text-2xl">
                  Cím
                </p>
              </div>
              <div
                class="w-5/12 px-[15px]"
              >
                <p class="text-2xl">
                  Előadó
                </p>
              </div>
              <div class="w-2/12 px-[15px]">
                <p class="text-2xl">
                  Album
                </p>
              </div>
            </div>
            <nuxt-link
              v-for="(item, index) in entities.data"
              :key="index"
              class="flex  flex-col lg:flex-wrap lg:flex-row mb-3 border border-white hover:border-red hover:border"
              :to="'/mediatar/felvetelek/' + item.id + '/' + item.slug"
            >
              <div class="lg:w-5/12 bg-white lg:bg-gray-lightest text-xl lg:text-2xl text-red font-source-serif-pro font-semibold p-[15px]">
                {{ item.title }}
              </div>
              <div class="flex flex-wrap  lg:block lg:w-5/12 bg-white lg:bg-gray-lightest p-[15px] px-[15px] lg:p-[15px] lg:border-white lg:border-l-2 lg:border-r-2">
                <img
                  class="w-[20px] lg:hidden mt-2 mr-2 self-start"
                  src="/img/performer_icon.svg"
                  alt=""
                >
                <span
                  v-for="(performer, index2) in item.performers"
                  :key="index2"
                  class="bg-[#DCDCDC] p-1 leading-8 mx-1 font-semibold"
                >
                  {{ performer.name }}
                </span>
              </div>
              <div class="flex  items-stretch lg:block lg:w-2/12 bg-white lg:bg-gray-lightest py-3 px-[15px] lg:p-[15px]">
                <img
                  class="w-[20px] lg:hidden self-start mt-1  mr-2"
                  src="/img/album_icon.svg"
                  alt=""
                >
                <p>{{ item.album && item.album.title ? item.album.title : "Nincs megadva" }}</p>
              </div>
            </nuxt-link>
          </div>
        </ReOverlayLoader>
      </div>  
    </section>
  </PageHeader>
</template>

<script>
import { cloneDeep } from "lodash";
import MediaSearch from "~/components/folkradio/searches/MediaSearch.vue";
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
const RePagination = () =>
  import("~/components/rxt/recomponent/RePagination.vue");
import scrollMixin from "~/mixins/scroll-fetch"
export default {
  components: {
    MediaSearch,
    RePagination,
    PageHeader,
    ReOverlayLoader,
  },
  mixins: [scrollMixin],
  head() {
    return {
      titleTemplate: "Felvételek | Médiatár",
      meta: [
        { hid: "title", name: "title", content: "Felvételek | Médiatár" },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: "Felvételek | Médiatár"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.$getDomain() + "/img/meta_default.png"
        },
        {
          hid: "description",
          name: "description",
          content: 'A Folkrádió hangtárában szereplő népzenei felvételek kereshető listája'
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: 'A Folkrádió hangtárában szereplő népzenei felvételek kereshető listája'
        }
      ]
    };
  },
  data() {
    return {
      queryUrl: "/media/recordings",
      loading:false
    };
  },
  watch: {
    $route(to, from) {
      this.$store.commit("search/setQueryObject", to.query);
      this.entities = {
        data: []
      }
      this.$fetch()
    }
  },
  async fetch() {
    let queryObject = { limit: 10, sort: "-created_at",
     include: 'album,performers', 
     'fields[performers]': 'performers.id,performers.name', 
     'fields[album]': 'music_albums.id,music_albums.title' };

    queryObject = Object.assign(
      queryObject,
      this.$router.history.current.query
    );

    this.$store.commit("search/setQueryObject", queryObject);

    await this.search();
  },
  methods: {
    searchChanged(queryObject) {
      this.$router.push({ query: queryObject });
    },
    //scroll fetch method
    getQueryString(){
      const queryObject = this.queryObject;
      if(!queryObject.limit)
        queryObject.limit = 25;

      // this.$store.commit("search/setQueryObject", queryObject);

      return decodeURIComponent(
        this.$createQueryString(queryObject)
      );
    },
    changeUrl(url) {
      this.$router.push(url);
    }
  }
};
</script>
